var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145.39,
    height: 96.849,
    viewBox: "0 0 38.469063 25.624557",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122.56 -185.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.7 185.39c-4.5659 6e-3 -11.628 0.1633-12.028 0.33609-0.58201 0.25133-10.804 10.784-11.038 11.373-0.0343 0.0863-0.0576 0.50074-0.0738 1.103 0.0161 0.60223 0.0395 1.0167 0.0738 1.103 0.23382 0.58926 10.456 11.122 11.038 11.373 0.40012 0.17279 7.4618 0.33039 12.028 0.33609 2.0754 3e-3 3.6351-0.0262 3.8192-0.0993 0.58925-0.23381 11.122-10.456 11.373-11.038 0.0479-0.1108 0.0945-0.73659 0.13718-1.6747-0.0426-0.93811-0.0893-1.5639-0.13718-1.6747-0.25134-0.58201-10.784-10.804-11.373-11.038-0.18414-0.0731-1.7438-0.1019-3.8192-0.0993z",
    strokeWidth: 0.14695
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOg);
export default __webpack_public_path__ + "static/media/og.d0fd879b6f3765ca098e9bb15bac668a.svg";
export { ForwardRef as ReactComponent };